export default __webpack_public_path__ + "static/media/msk.cd42c535.svg";